import {
  FileEvidenceDetailsType,
  Maybe,
  ParsedEvidenceDetailsType,
} from 'src/graphql';
import { returnDashIfNoValue } from 'src/utils/returnDashIfNoValue';
import {
  hiddenDate,
  hiddenDots,
  hiddenTime,
} from '../pages/Case/helpers/hiddenDots';

type EvidenceArray = FileEvidenceDetailsType[] | ParsedEvidenceDetailsType[];
type FormatValue = string | Maybe<EvidenceArray> | undefined;
type FormatType = 'date' | 'time' | 'string' | 'array';

export const formatDashOrHidden = <T extends FormatType>(
  value: FormatValue,
  type: T,
  canView?: boolean,
): T extends 'array' ? EvidenceArray : string => {
  type Result = T extends 'array' ? EvidenceArray : string;

  if (!canView) {
    if (type === 'date') {
      return hiddenDate as Result;
    }
    if (type === 'time') {
      return hiddenTime as Result;
    }
    if (type === 'array') {
      return [] as EvidenceArray as Result;
    }
    return hiddenDots as Result;
  }

  if (type === 'array' || typeof value === 'object') {
    return (value || []) as Result;
  }

  return returnDashIfNoValue(value) as Result;
};
